import axios from "axios";
import { LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS, ME_SUCCESS } from "../constats/auth.constant";
import { endpoint, endpointApi } from "../../utils";
import { setLoading } from "./loader.action";

export const login = (email, password, redirect=null, navigate=null) => async(dispatch) => {
    try {
        dispatch({
            type: LOGIN_REQUEST
        });
        const { data } = await axios.post(`${ endpoint }api/auth/login`, {email, password}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });  
        localStorage.setItem('jwt_access', data.token);
        redirect = redirect ? redirect : '/';
        if(navigate){
            dispatch({
                type: LOGIN_SUCCESS
            });
            navigate(redirect);
        }else{
            window.location.href = redirect;
        }
    } catch (err) {
        dispatch({
            type: LOGIN_FAIL,
            payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
        });
    }
}

export const logout = (redirect=null, navigate=null) => (dispatch) => {
    localStorage.removeItem('jwt_access');
    redirect = redirect ? "/login?redirect_to=" + redirect : "/login";
    dispatch(setLoading(false));
    if(navigate){
        navigate(redirect);
    }else{
        window.location.href = redirect;
    }
}

export const setMe = (me) => (dispatch) => {
    dispatch({
        type: ME_SUCCESS,
        payload: me
    });
}

export const getMe = (redirect=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        const { data } = await axios.get(`${ endpointApi }me`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch(setMe(data));
    } catch (err) {
        if(err.response.status === 401){
            dispatch(logout(redirect, navigate));
        }
    }
}